import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import SEOHead from "@/components/SEOHead";

const breadcrumbLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Início", item: "https://indexrerum.com/" },
    { "@type": "ListItem", position: 2, name: "Termos e Condições", item: "https://indexrerum.com/termos" },
  ],
};

const Terms = forwardRef<HTMLDivElement>((_, ref) => (
  <div ref={ref} className="min-h-screen bg-background">
    <SEOHead
      title="Termos e Condições | Index Rerum"
      description="Consulte os termos e condições de utilização da plataforma Index Rerum para gestão de património e inventário museológico."
      canonicalPath="/termos"
      jsonLd={breadcrumbLd}
    />
    <Navbar />
    <div className="container mx-auto px-4 py-16 pt-28 max-w-3xl">
      <h1 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-2">Termos e Condições</h1>
      <p className="text-muted-foreground mb-10">Última atualização: março de 2026</p>

      <div className="prose prose-neutral max-w-none space-y-8 text-foreground/80">
        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">1. Objeto</h2>
          <p>Os presentes Termos e Condições regulam o acesso e utilização da plataforma Index Rerum, propriedade da EVOKE IT, destinada à gestão de inventário e património.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">2. Acesso à Plataforma</h2>
          <p>O acesso à plataforma requer registo prévio e está sujeito à aprovação pela EVOKE IT. O utilizador compromete-se a fornecer informações verdadeiras e a manter a confidencialidade das suas credenciais de acesso.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">3. Utilização</h2>
          <p>O utilizador compromete-se a utilizar a plataforma de forma lícita, não podendo:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Utilizar a plataforma para fins ilegais ou não autorizados</li>
            <li>Tentar aceder a áreas restritas sem autorização</li>
            <li>Introduzir vírus ou código malicioso</li>
            <li>Reproduzir, copiar ou distribuir conteúdos da plataforma sem autorização</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">4. Propriedade Intelectual</h2>
          <p>Todos os conteúdos, design, código-fonte e funcionalidades da plataforma Index Rerum são propriedade exclusiva da EVOKE IT e encontram-se protegidos pela legislação aplicável em matéria de propriedade intelectual.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">5. Limitação de Responsabilidade</h2>
          <p>A EVOKE IT não se responsabiliza por danos diretos ou indiretos resultantes da utilização ou impossibilidade de utilização da plataforma, incluindo perda de dados ou interrupção de serviço.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">6. Alterações</h2>
          <p>A EVOKE IT reserva-se o direito de alterar os presentes Termos e Condições a qualquer momento, sendo os utilizadores notificados das alterações relevantes.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">7. Lei Aplicável</h2>
          <p>Os presentes Termos e Condições são regidos pela legislação portuguesa. Para a resolução de qualquer litígio será competente o foro da comarca da sede da EVOKE IT.</p>
        </section>
      </div>

      <div className="mt-16 pb-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft size={16} /> Voltar
        </Link>
      </div>
    </div>
  </div>
));

Terms.displayName = "Terms";

export default Terms;
